import { render, staticRenderFns } from "./Licence.vue?vue&type=template&id=a7019a9c"
import script from "./Licence.vue?vue&type=script&lang=js"
export * from "./Licence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports